// @flow
import shopApiRequest from 'app/actions/shopApi';
import action from 'app/common/lib/action';


export const SHOP_DELETECART_REQUEST = 'SHOP_DELETECART_REQUEST';
export const SHOP_DELETECART_SUCCESS = 'SHOP_DELETECART_SUCCESS';
export const SHOP_DELETECART_FAILURE = 'SHOP_DELETECART_FAILURE';


/**
 * Удаление записи в корзине
 */
export const deleteCartItem = (itemId: string) => async (dispatch: Function, getState: Function) => {
  const cartId = getState().shop.cart.id;
  dispatch(action(SHOP_DELETECART_REQUEST, { cartId, itemId }));
  try {
    await shopApiRequest(`carts/${cartId}/cart_items/${itemId}`, 'delete');
    dispatch(action(SHOP_DELETECART_SUCCESS, { itemId }));
    return true;
  } catch (error) {
    dispatch(action(SHOP_DELETECART_FAILURE, {
      err: 'Удалить товар из корзины не удалось',
      data: { cartId, itemId },
      error,
    }));
    return false;
  }
};
